import { useState } from "react";
import { API } from "@/lib/api";
import { Building2 } from "lucide-react";

// Logo from the client profile, falling back to the invoice-settings logo (served by /api/clients/{id}/logo).
// `v` = client.logo_v from /api/clients ("" means no logo, so no request is made).
export function ClientLogo({ id, className = "h-9 w-9", icon = "h-4 w-4", v }) {
  const [failed, setFailed] = useState("");
  const key = `${id}|${v}`;
  const show = id && v !== "" && failed !== key;
  return (
    <div className={`${className} rounded-md bg-secondary flex items-center justify-center overflow-hidden shrink-0`} data-testid={`client-logo-${id}`}>
      {show
        ? <img src={`${API}/clients/${id}/logo${v ? `?v=${encodeURIComponent(v)}` : ""}`} alt="" className="max-h-full max-w-full object-contain" onError={() => setFailed(key)} />
        : <Building2 className={`${icon} text-muted-foreground`} />}
    </div>
  );
}
